import Vue from 'vue';
import Component from 'vue-class-component';

import getLastTld from 'common/services/utils/getLastTld';

import useFilters from 'composables/useFilters';

import Card from 'components/DynamicFilters/Card/Card.vue';

import box from 'common/icons/Gift2.svg';
import activity from 'common/icons/Spark.svg';
import travel from 'common/icons/Map.svg';

@Component({
  components: {
    Card,
    // OrderBy,
  },
  props: {
    optionsToDisplay: {
      type: Array,
      required: true,
      description: 'Array of strings with options to display',
      default: ['box', 'activity', 'travelUy'],
    },
  },
  setup() {
    const { getOptionCards } = useFilters();
    return {
      optionCards: getOptionCards,
    };
  },
})
export default class OptionCardsComponent extends Vue {
  icons = {
    box,
    activity,
    travelUy: travel,
  };

  shouldShowOption(option, optionsToDisplay, getLastTld) {
    if (option.name === 'travelUy') {
      return getLastTld() === 'uy';
    } else {
      return optionsToDisplay.includes(option.name);
    }
  }

  get isRetailMode() {
    return this.$route.query?.retail === 'true';
  }

  options = this.optionCards.map((option, index) => {
    return {
      id: index,
      name: option.name,
      icon: this.icons[option.name],
      title: this.isRetailMode ? option.retailTitle : option.title,
      description: option.description,
      show: this.shouldShowOption(option, this.optionsToDisplay, getLastTld),
    };
  });
}
